export default __webpack_public_path__ + "static/media/info-policia.2522c8b8.svg";